/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { GET_CREDENTIALS_CLIQUE_RETIRE } from './graphql';

export function useGetCliqueRetireCredentials({ storeId } = {}) {
  const { setLoading, setErrorMessage } = useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({ apiKey: '', apiId: '' });
  const [GetCliqueRetireCredentials, { loading: apiLoading }] = useLazyQuery(
    GET_CREDENTIALS_CLIQUE_RETIRE,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    if (apiLoading) {
      setIsLoading(true);
      setLoading(true);
    } else {
      setIsLoading(false);
      setLoading(false);
    }
  }, [apiLoading]);

  async function getCliqueRetireCredentials(newStoreId) {
    try {
      const res = await GetCliqueRetireCredentials({
        variables: { storeId: newStoreId || storeId },
      });
      if (res.data.getCliqueRetireCredentials.code === 200) {
        const { apiKey, apiId } =
          res.data.getCliqueRetireCredentials.credentials;
        setCredentials({
          apiKey,
          apiId,
        });
      } else {
        setCredentials({ apiKey: '', apiId: '' });
      }
    } catch (e) {
      setErrorMessage(
        'Não foi possível obter as credenciais CliqueRetire, tente novamente mais tarde.',
      );
    }
  }

  useEffect(() => {
    if (storeId) {
      getCliqueRetireCredentials(storeId);
    }
  }, [storeId]);

  return {
    getCliqueRetireCredentials,
    credentials,
    setCredentials,
    loading: isLoading,
  };
}
